import { Typography } from "@beamcloud/design-system";
import NavLink from "components/NavLink";
import React from "react";
import {
  SectionSubtitle as PrimitiveSectionSubtitle,
  SectionTitle as PrimitiveSectionTitle,
} from "screens/Homepage/styles";
import styled, { css } from "styled-components";
import { Helmet } from "react-helmet-async";

const IntroSection: React.FC = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Our Company & Vision • Beam</title>
      </Helmet>
      <Container>
        <TitleSection>
          <Typography tag="h2" variant="headingXl" color="gray11">
            What's this about?
          </Typography>
          <SectionTitle>The Cloud Platform We Always Wanted</SectionTitle>
          <br></br>
          <SectionSubtitle>
            Running apps in the cloud can be{" "}
            <StyledNavLink href={"https://beam.cloud/blog/manifesto"}>painful</StyledNavLink>. If you're like
            us, you want to ship products fast — without having to manage servers, Dockerfiles, or security
            groups. <br></br>
            <br></br>
            We built Beam because we wanted to ship ML products faster, without the pain of managing infra
            ourselves.
            <br></br>
            <br></br>
            Today, thousands of developers use Beam to build their applications, without ever having to think
            about cloud infrastructure.
            <br></br>
            <br></br>
            Beam is the product we always wanted for ourselves.
            <br></br>
            <br></br>
            We think it's pretty cool.
          </SectionSubtitle>
        </TitleSection>
      </Container>
      <Transition />
    </React.Fragment>
  );
};

export default IntroSection;

const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    text-align: center;
    background: linear-gradient(180deg, rgba(23, 24, 28, 0) 0%, #1d1f24 100%);

    padding: 64px 16px;

    @media (min-width: ${theme.breakpoints.sm}px) {
      padding: 64px 32px;
    }

    @media (min-width: ${theme.breakpoints.md}px) {
      padding: 64px 48px;
    }

    @media (min-width: ${theme.breakpoints.lg}px) {
      padding: 64px 32px;
    }

    @media (min-width: ${theme.breakpoints.xl}px) {
      padding: 64px 64px;
    }
  `}
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 12px;
  max-width: 740px;
`;

const SectionTitle = styled(PrimitiveSectionTitle)`
  max-width: initial;
  text-align: initial;
`;

const SectionSubtitle = styled(PrimitiveSectionSubtitle)`
  max-width: initial;
  text-align: initial;
`;

const Transition = styled.div`
  height: 0;
  width: 0;
  border-top: 96px solid ${props => props.theme.colors.gray850};
  border-right: 100vw solid ${props => props.theme.colors.gray2};
`;

const StyledNavLink = styled(NavLink)`
  && {
    text-decoration: underline;
    &:hover {
      text-decoration: underline;
    }
  }
`;
